import React, {useRef, useState} from 'react'
import {FormControl} from "@mui/material";
import {useStyles} from "./RegistrationSection.css";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import {NavLink} from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import useSelfRegistration from "./useSelfRegistration";
import GeneralEditUserForm from "../../../admin/sections/users/utils/GeneralEditUserForm";
import LoadingProgressIndication from "../../elements/progress/loading/LoadingProgressIndication";
import {useIntl} from "react-intl";

const RegistrationSection = () => {
    const classes = useStyles()

    const {registerUser, registrationInProgress} = useSelfRegistration()

    // Reference, which holds will hold the user data according to the current form data (from the general user component)
    const editedUserRef = useRef()

    // Determines if the save button should be enabled.
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    if (registrationInProgress) {
        return <LoadingProgressIndication text={intl.formatMessage({
            id: 'app.signUp.registration.loading',
            defaultMessage: 'Registration...'
        })}/>
    }

    return (
        <div className={classes.root}>
            <Avatar className={classes.avatar}>
                <PersonAddIcon className={classes.signUpIcon}/>
            </Avatar>
            <Typography component="h1" variant="h5">
                {intl.formatMessage({
                    id: 'app.signUp.form.header',
                    defaultMessage: 'Sign Up'
                })}
            </Typography>
            <GeneralEditUserForm
                editedUserRef={editedUserRef}
                setSaveButtonEnabled={setSaveButtonEnabled}/>
            <div className={classes.container}>
                <FormControl className={classes.formControl}>
                    <Button variant="contained"
                            color="primary"
                            disabled={!saveButtonEnabled}
                            onClick={() => registerUser(editedUserRef.current)}>
                        {intl.formatMessage({
                            id: 'app.signUp.form.action.signUp',
                            defaultMessage: 'Sign Up'
                        })}
                    </Button>
                </FormControl>

                <FormControl className={classes.formControl}>
                    <Button component={NavLink} to="/" variant="outlined" color="secondary">
                        {intl.formatMessage({
                            id: 'app.signUp.form.action.cancel',
                            defaultMessage: 'Cancel'
                        })}
                    </Button>
                </FormControl>
            </div>
        </div>
    )
}

export default RegistrationSection
